import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
  getTasks,
  viewretailersByid,
  assignTask,
  getcitiesfiter,
  getdropdowncities,
} from "./api";
import { getToken } from "../../utils/utils";
import PaginationComponent from "../brands/Pagination";

const columns: GridColDef[] = [
  { field: "retailer_id", headerName: "Retailer ID", width: 70 }, // Replace 'id' with 'retailer_id'
  { field: "account_id", headerName: "Account ID", width: 150 },
  { field: "contact_id", headerName: "Contact ID", width: 150 },
  { field: "name", headerName: "Name", width: 200 },
  { field: "billingstreet", headerName: "Billing Street", width: 200 },
  { field: "location_type", headerName: "Location Type", width: 150 },
  { field: "billing_state", headerName: "Billing State", width: 150 },
  { field: "billing_country", headerName: "Country", width: 150 },
  { field: "active", headerName: "Active", width: 100 },
  { field: "approved_status", headerName: "Approved Status", width: 100 },
];

const TaskAssignment: React.FC = () => {
  const [tasks, setTasks] = useState<any[]>([]);
  const [retailers, setRetailers] = useState<any[]>([]);
  const [filteredRetailers, setFilteredRetailers] = useState<any[]>([]);
  const [selectedTaskId, setSelectedTaskId] = useState<number | null>(null);
  const [selectedRetailers, setSelectedRetailers] = useState<number[]>([]);
  const [filterCity, setFilterCity] = useState<string>("");
  const [filterOutlet, setFilterOutlet] = useState<string>("");
  const [dropdowncities, setdropdowncities] = useState<any[]>([]);
  const token = getToken();

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const response = await getTasks(token);
        const mappedTasks = response.data.data.map((task: any) => ({
          id: task.task_id,
          name: task.task_en,
        }));
        setTasks(mappedTasks);
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
    };

    fetchTasks();
  }, [token]);

  useEffect(() => {
    const fetchdropdowncities = async () => {
      try {
        const response = await getdropdowncities();

        console.log(
          JSON.stringify(response.data, null, 2),
          "citiescitiescites"
        );

        setdropdowncities(response.data.data);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    fetchdropdowncities();
  }, []);

  const fetchRetailers = async (task_id: number) => {
    try {
      const response = await viewretailersByid(token, task_id);
      const mappedRetailers = response.data.data.map((retailer: any) => ({
        retailer_id: retailer["retailer.id"], // Map retailer_id here
        account_id: retailer["account.account_id"],
        contact_id: retailer["retailer.contact_id"],
        name: retailer["retailer.first_name"],
        billingstreet: retailer["account.billingstreet"],
        location_type: retailer["account.location_type"],
        billing_state: retailer["account.billing_state"],
        billing_country: retailer["account.billing_country"],
        active: retailer["account.active"],
        approved_status: retailer.approval_status,
      }));
      setRetailers(mappedRetailers);
      setFilteredRetailers(mappedRetailers);
    } catch (error) {
      console.error("Error fetching retailers:", error);
    }
  };

  const fetchRetailersByCity = async (task_id: number, city_name: string) => {
    try {
      const response = await getcitiesfiter(
        token,
        task_id.toString(),
        city_name
      );
      console.log(response.data.data.length, "llllllllllllllll");
      const mappedRetailers = response.data.data.map((retailer: any) => ({
        id: retailer.id,
        account_id: retailer.account_id,
        contact_id: retailer.contact_id,
        account_no: retailer.account_no,
        name: retailer.name,
        billingstreet: retailer.billingstreet,
        location_type: retailer.location_type,
        billing_state: retailer.billing_state,
        billing_country: retailer.billing_country,
        active: retailer.active,
        approved_status: retailer.approval_status,
      }));
      setFilteredRetailers(mappedRetailers);
    } catch (error) {
      console.error("Error fetching retailers by city:", error);
    }
  };

  const handleSave = async () => {
    if (!selectedTaskId) {
      alert("Please select a task.");
      return;
    }
    if (selectedRetailers.length === 0) {
      alert("Please select at least one retailer.");
      return;
    }
    try {
      await assignTask(token, String(selectedTaskId), selectedRetailers);
      alert("Task assigned successfully!");
      setSelectedTaskId(null);
      setSelectedRetailers([]);
    } catch (error) {
      console.error("Error assigning task:", error);
      alert("Failed to assign task. Please try again.");
    }
  };
  const combinedRetailers = filterCity ? filteredRetailers : retailers;
  console.log(
    JSON.stringify(combinedRetailers, null, 2),
    "combinedRetailerscombinedRetailerscombinedRetailerscombinedRetailers"
  );

  return (
    <Box p={3}>
      <Typography sx={{ marginBottom: "34px" }} variant="h4">
        Assign Tasks
      </Typography>

      <Box mb={3}>
        <FormControl fullWidth>
          <InputLabel id="task-select-label">Select Task</InputLabel>
          <Select
            labelId="task-select-label"
            value={selectedTaskId || ""}
            onChange={(e) => {
              const taskId = Number(e.target.value);
              setSelectedTaskId(taskId);
              fetchRetailers(taskId);
            }}
            label="Select Task"
          >
            {tasks.map((task) => (
              <MenuItem key={task.id} value={task.id}>
                {task.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box mb={3}>
        <FormControl fullWidth>
          <InputLabel id="city-filter-label">Filter by City</InputLabel>
          <Select
            labelId="city-filter-label"
            value={filterCity}
            onChange={(e) => {
              const cityValue = e.target.value as string;
              setFilterCity(cityValue);
              if (selectedTaskId)
                fetchRetailersByCity(selectedTaskId, cityValue);
            }}
            label="Filter by City"
          >
            {dropdowncities.map((city: string, index: number) => (
              <MenuItem key={index} value={city}>
                {city}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box mb={3}>
        <FormControl fullWidth>
          <InputLabel id="outlet-filter-label">Filter by Outlet</InputLabel>
          <Select
            labelId="outlet-filter-label"
            value={filterOutlet}
            onChange={(e) => setFilterOutlet(e.target.value)}
            label="Filter by Outlet"
          >
            <MenuItem value="">All Outlets</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <div style={{ height: 400, width: "100%" }}>
        {filteredRetailers.length === 0 ? (
          <Typography variant="h6" color="textSecondary" align="center">
            No results found
          </Typography>
        ) : (
          <DataGrid
            rows={combinedRetailers}
            getRowId={(row) => row.retailer_id}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10 },
              },
              columns: {
                columnVisibilityModel: {
                  approval_status: false,
                },
              },
            }}
            checkboxSelection
            isRowSelectable={(params) => params.row.approved_status === null}
            onRowSelectionModelChange={(newSelection) => {
              setSelectedRetailers(newSelection as number[]);
            }}
            rowSelectionModel={selectedRetailers}
          />
        )}
      </div>


      <Box mt={3}>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Assign Task
        </Button>
      </Box>
    </Box>
  );
};

export default TaskAssignment;
